export const MULTIPLEMODEL_LIST = 'MULTIPLEMODEL_LIST';
export const MULTIPLEMODEL_LIST_SUCCESS = 'MULTIPLEMODEL_LIST_SUCCESS';
export const MULTIPLEMODEL_LIST_ERROR = 'MULTIPLEMODEL_LIST_ERROR';

export const MULTIPLEMODEL_LIST_DETAILS = 'MULTIPLEMODEL_LIST_DETAILS';
export const MULTIPLEMODEL_LIST_DETAILS_SUCCESS = 'MULTIPLEMODEL_LIST_DETAILS_SUCCESS';
export const MULTIPLEMODEL_LIST_DETAILS_ERROR = 'MULTIPLEMODEL_LIST_DETAILS_ERROR';

export const ADD_MULTIPLEMODEL_LIST_DETAILS = 'ADD_MULTIPLEMODEL_LIST_DETAILS';
export const ADD_MULTIPLEMODEL_LIST_DETAILS_SUCCESS = 'ADD_MULTIPLEMODEL_LIST_DETAILS_SUCCESS';
export const ADD_MULTIPLEMODEL_LIST_DETAILS_ERROR = 'ADD_MULTIPLEMODEL_LIST_DETAILS_ERROR';

export const UPDATE_MULTIPLEMODEL_LIST_DETAILS = 'UPDATE_MULTIPLEMODEL_LIST_DETAILS';
export const UPDATE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS = 'UPDATE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS';
export const UPDATE_MULTIPLEMODEL_LIST_DETAILS_ERROR = 'UPDATE_MULTIPLEMODEL_LIST_DETAILS_ERROR';

export const DELETE_MULTIPLEMODEL_LIST_DETAILS = 'DELETE_MULTIPLEMODEL_LIST_DETAILS';
export const DELETE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS = 'DELETE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS';
export const DELETE_MULTIPLEMODEL_LIST_DETAILS_ERROR = 'DELETE_MULTIPLEMODEL_LIST_DETAILS_ERROR';

export const MODEL_CLASSIFICATIONS = 'MODEL_CLASSIFICATIONS';
export const MODEL_CLASSIFICATIONS_SUCCESS = 'MODEL_CLASSIFICATIONS_SUCCESS';
export const MODEL_CLASSIFICATIONS_ERROR = 'MODEL_CLASSIFICATIONS_ERROR';

export const DATA_GENERATIONTYPE = 'DATA_GENERATIONTYPE';
export const DATA_GENERATIONTYPE_SUCCESS = 'DATA_GENERATIONTYPE_SUCCESS';
export const DATA_GENERATIONTYPE_ERROR = 'DATA_GENERATIONTYPE_ERROR';


export const MODELTYPE_LIST = 'MODELTYPE_LIST';
export const MODELTYPE_LIST_SUCCESS = 'MODELTYPE_LIST_SUCCESS';
export const MODELTYPE_LIST_ERROR = 'MODELTYPE_LIST_ERROR';

export const DETECTIONALG_LIST = 'DETECTIONALG_LIST';
export const DETECTIONALG_LIST_SUCCESS = 'DETECTIONALG_LIST_SUCCESS';
export const DETECTIONALG_LIST_ERROR = 'DETECTIONALG_LIST_ERROR';
